import api from './api';

export const getARaging = () =>
  api.get('/api/v1/reports/ar-aging').then((r) => r.data.data);

export const getRevenueSummary = (months = 12) =>
  api.get('/api/v1/reports/revenue', { params: { months } }).then((r) => r.data.data);

export const getClaimStats = () =>
  api.get('/api/v1/reports/claims').then((r) => r.data.data);

export const getInsuranceAR = () =>
  api.get('/api/v1/reports/insurance-ar').then((r) => r.data.data);

export const getCPTUtilization = () =>
  api.get('/api/v1/reports/cpt-utilization').then((r) => r.data.data);

export const getReminderSettings = () =>
  api.get('/api/v1/settings/reminders').then((r) => r.data.data);

export const updateReminderSettings = (data) =>
  api.put('/api/v1/settings/reminders', data).then((r) => r.data);
